import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE, SECTIONS_IDS } from "./constants";

const iniState = {
  loading: true,
  preferences: {
    field_widths: {}
  },
  addLoading: {},
  scope: "home",
  title: "",
  background_image_url: "",
  enable_community_hub: false,
  community_hub_title: null,
  community_hub_description: null,
  description: "",
  percent_complete: "",
  show_sessions: false,
  show_tasks: true,
  count_of_schedule_items: 0,
  // tabs: TABS,
  dueDate: false,
  // filters: GROUP_BY,
  showDocumentRequestModal: false,
  recordId: null,
  submissionsFilter: {},
  activeSubmissionTab: {},
  submissionId: "",
  //
  portalMeta: {},
  links: [],
  tasks: [],
  taskOrder: {},
  sessionsTasks: [],
  files: [],
  pages: [],
  alerts: [],
  sessions: [],
  applications: [],
  gleanin_links: [],
  styles: {
    logo_image_url: null,
    background_image_url: null,
    logo_alt_text: null,
    background_image_url_alt_text: null,
    enable_background_full_width: false,
    button_color: null,
    button_text_color: null,
    background_color: null,
    portal_name_font: null,
    portal_name_size: null,
    portal_name_color: null,
    section_header_font: null,
    section_header_size: null,
    section_header_color: null,
    section_header_text: null,
    css_code: null
  },
  selectedCategory: SECTIONS_IDS.HOME,
  shouldScrollToSection: false,
  activeWikiPage: null,
  enableManageProfile: false,
  enableManageSessions: false,
  visibleSessionFieldIds: [],
  enableViewSessionSubmissionForm: true
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    goHomeFromWikiPage: R.identity,
    navigateTo: R.identity,
    setInitialData: (
      _,
      {
        payload: {
          visible_session_field_ids,
          enable_manage_profile,
          enable_manage_sessions,
          enable_view_session_submission_form,
          preferences,
          title,
          background_image_url,
          enable_community_hub,
          community_hub_title,
          community_hub_description,
          description,
          percent_complete,
          show_sessions,
          show_tasks,
          count_of_schedule_items,
          // tableDataList,
          //
          links,
          meta,
          tasks,
          task_order,
          files,
          pages,
          alerts,
          sessions,
          applications,
          gleanin_links,
          styles,
          sessionsTasks
        }
      }
    ) => {
      return {
        loading: false,
        preferences,
        title,
        background_image_url,
        enable_community_hub,
        community_hub_title,
        community_hub_description,
        description,
        percent_complete,
        show_sessions,
        show_tasks,
        count_of_schedule_items,
        links,
        portalMeta: meta,
        taskOrder: task_order,
        tasks,
        files,
        pages,
        alerts,
        sessions,
        applications,
        gleanin_links,
        styles,
        sessionsTasks,
        enableManageProfile: enable_manage_profile,
        enableManageSessions: enable_manage_sessions,
        enableViewSessionSubmissionForm: enable_view_session_submission_form,
        visibleSessionFieldIds: visible_session_field_ids
      };
    }
    // goToSection: (state, { payload }) => ({
    //   selectedCategory: payload
    // })
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
